export const VECTOR = 'mapbox://styles/mapbox/navigation-day-v1';
export const SATELLITE = 'mapbox://styles/mapbox/satellite-v9';
